<template>
  <div class="mt-4">
    <CommunityForm v-model="community"
      :conditions="conditions"
      :reload-conditions="reloadConditions"
      @reloaded="list => conditions = list"
      @cancel="$router.push({name: 'admin-communities'})"
      @save="save"
    />
  </div>
</template>

<script>

import CommunityService from "@/modules/Admin/Services/CommunityService";
import CommunityForm from "@/modules/Admin/Components/Communities/CommunityForm";
import store from "@/modules/Shared/Store/store";
import loader from "@/modules/Shared/Mixins/loader";
import {unifyPaginatedResponse} from "@/modules/Shared/Helpers/apiResponseHelper";
import AppConditionsService from "@/modules/Admin/Services/AppConditionsService";
import { isPickerMode, notifyCreatedAndClose } from "@/modules/Shared/Helpers/creatableSelectPicker";

export default {
  name: "EditCommunityPage",
  components: { CommunityForm },
  mixins: [loader],

  data() {
    return {
      community: null,
      new: true,
      conditions: []
    }
  },

  async beforeRouteEnter (to, from, next) {
      let defaultCommunity = {
        uuid: to.params.uuid,
        name: '',
        transactional_templates_prefix: '-',
        transactionals_sender_email: '',
        auto_validate_users: false,
        transactional_mail_provider: 'mailjet',
      }
      const community = await CommunityService.getCommunity(to.params.uuid);
      const conditions = await unifyPaginatedResponse(AppConditionsService.getAppConditions, {q: 'current:1'})

      await store.dispatch('setRouteElement', community)
      next(vm => {
        vm.community = community || defaultCommunity
        vm.new = !community
        vm.conditions = conditions
      })
  },

  methods: {
    async reloadConditions() {
      this.conditions = await unifyPaginatedResponse(AppConditionsService.getAppConditions, {q: 'current:1'})
      return this.conditions
    },
    save() {
      this.loadAndNotify(async () => {
        if (this.new) {
          await CommunityService.createCommunity(this.community.uuid, this.community);
        } else {
          await CommunityService.updateCommunity(this.community.uuid, this.community);
        }

        if (isPickerMode(this.$route)) {
          notifyCreatedAndClose({ uuid: this.community.uuid });
        }
      })
    }
  }
};
</script>
